import { render, staticRenderFns } from "./GameStateModal.vue?vue&type=template&id=5fa52943&scoped=true"
import script from "./GameStateModal.vue?vue&type=script&lang=js"
export * from "./GameStateModal.vue?vue&type=script&lang=js"
import style0 from "./GameStateModal.vue?vue&type=style&index=0&id=5fa52943&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa52943",
  null
  
)

export default component.exports